import React from 'react';
import styled from 'styled-components';
import { media } from '@amtrav/themes';
import { getNavigationLogo } from '@amtrav/view-components';
import { getConfigValue, THEME_CONFIG } from '@amtrav/theme-system';

const ContainLogo = styled.div`
  display: inline-flex;
  align-items: flex-start;
  position: relative;

  ${media.Large`
    width: 80%;
  `}
`;

const Logo = styled.a`
  width: 100%;
  margin: 0 auto;
  padding: 0;
  display: flex;
  transition: opacity 0.3s;
  height: 48px;
  padding: 6px 0;

  ${media.Large`
  padding: 4px 0;
  padding: 0;
  justify-content: space-around;
  align-content: center;
  height: 77px;
  `}

  svg {
    position: absolute;
    height: 100%;

    ${media.Large`
      width: 100%;
    `}
  }
`;

const NavLogo = () => {
  const navLogoToken = getConfigValue(THEME_CONFIG.navigation.id.logo);
  return getNavigationLogo(navLogoToken);
};

const SiteLogo = () => (
  <Logo href="/">
    <ContainLogo>
      <NavLogo />
    </ContainLogo>
  </Logo>
);

SiteLogo.propTypes = {};

SiteLogo.defaultProps = {};

export default SiteLogo;
